import React from 'react'

const Manual_subir_terminos_condiciones = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Subir términos y condiciones
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende a cargar los términos y condiciones de tu tienda para mostrar información legal a tus clientes.
        </p>
        <iframe
          src="https://scribehow.com/embed/Subir_terminos_y_condiciones__U-smr0c8R0Wzayfnq6TCTw?as=scrollable"
          className="scribe-iframe-general-111"
          width="100%"
          height="2500"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_subir_terminos_condiciones
